import { Collection } from "./Collection";
import * as THREE from '@phdsoft/three';

export class SensorCollection extends Collection {
  constructor(date: Date) {
    super(date);
    this.Type = 'SensorCampaign';
  }


  public changeSensorMaterials(material: THREE.Material): void {
    for (const surfaceElement of this.SurfaceElements) {
        surfaceElement.currentRenderMaterial = material;
    }
  }
}
